import { init, loop, obj, on, pool, setScale, downloadAsImage } from "./app.js";
import { $$, getMouseCoords } from "./utils.js";

const SCALE = 32;

init();
setScale(SCALE, SCALE);

let currentColor = "#0f380f";
let mouseDown = false;

const objs = Array.from({ length: 16 }, (_, x) =>
  Array.from({ length: 16 }, (_, y) =>
    obj({ x: x * SCALE, y: y * SCALE, color: "#bdae58" })
  )
).flat();

const pixels = pool(objs);

const hover = obj({
  color: currentColor,
  width: 1,
  height: 1,
  render(ctx, attributes) {
    ctx.fillStyle = attributes.color;
    ctx.fillRect(attributes.x, attributes.y, 1, 1);
  },
});

const app = loop({
  update: () => {
    pixels.update();
    hover.update();
  },
});

app.start();

on("click", (event) => {
  const { x, y } = getMouseCoords(event);

  const pixel = obj({
    color: currentColor,
    x,
    y,
  });

  pixels.add(pixel);
});

on("mousemove", (event) => {
  const { x, y } = getMouseCoords(event);

  hover.color = currentColor;
  hover.x = Math.floor(x / SCALE);
  hover.y = Math.floor(y / SCALE);

  if (mouseDown) {
    const pixel = obj({ x, y, color: currentColor });
    pixels.add(pixel);
  }
});

on("mouseout", () => {
  hover.x = null;
  hover.y = null;
  mouseDown = false;
});

on("mousedown", () => {
  mouseDown = true;
});

on("mouseup", () => {
  mouseDown = false;
});

function handlePickerClick(event) {
  event.preventDefault();
  currentColor = event.target.value;
}

function handleClear() {
  pixels.empty();
}

function handleExport() {
  downloadAsImage();
}

const pickers = document.querySelectorAll(".picker button");
for (const picker of pickers) {
  picker.addEventListener("click", handlePickerClick);
}

$$(".clear").addEventListener("click", handleClear);
$$(".export").addEventListener("click", handleExport);
